export default __webpack_public_path__ + "static/media/platform-illustration.960f861d.png";